import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
  agencyData:{
    approved_at:null,
    reviewer_message:null,
    name:null,
    description:null,
    logo_url:null,
    email:null,
    phone_number:null,
    id:null,
  }
};
const getters = {
  agencyData: (state) => state.agencyData,
};

const actions = {
  [actionType.GET_AGENCIES]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("admin/agencies",{params}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_ONE_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`admin/agencies/${params.id}`,).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_ONE_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.delete(`admin/agencies/${params.id}`,).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.ADD_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`admin/agencies`,params).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.UPDATE_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`admin/agencies/${params.id}`,params.body).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  
  [actionType.VERIFY_USER_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`user/agencies`).then(result => {
        commit(mutationType.SET_AGENCY_DATA, {
          data: result.data.data
        })
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_USER_FOR_AGENCY_BY_EMAIL]: async function ({ commit }, params) {
    console.log("params.",params)
    return new Promise((resolve, reject) => {
      api.get(`user/agencies/agents`,{params}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.ADD_AGENT_TO_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`user/agencies/${params.id}/agents/`,params).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_AGENT_FOR_AGENCY]: async function ({ commit }, params) {
    console.log("params",params)
    return new Promise((resolve, reject) => {
      api.get(`user/agencies/${params.id}/agents`,{params}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_AGENT_FOR_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.delete(`user/agencies/${params.id}/agents/${params.agentId}`).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },

  [actionType.USER_CREATE_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`user/agencies`,params).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.USER_UPDATE_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`user/agencies/${params.agencyId}`,params.formData).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.APPROVE_OR_REJECT_AGENCY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.put(`admin/agencies/${params.agencyId}/review`,{approved:params.approved,reviewer_message:params.reviewer_message}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.ACTIVE_AGENTS_INVITATION]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.post(`user/agencies/agents/invitations?invitation_code=${params.invitationCode}`,{}).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_PENDING_AGENTS]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/user/agencies/agents/invitations/pending`).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_LISTING_ERROR_XML]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get(`/user/agencies/xml/errors`).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
  [actionType.DELETE_PENDING_INVITATION_OF_AGENT]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.delete(`/user/agencies/agents/invitations/${params.id}`).then(result => {
        resolve(result);
      })
        .catch(error => reject(error));
    });
  },
};

const mutations = {
  [mutationType.SET_AGENCY_DATA]: function(state, data){
    console.log(":data SET_AGENCY_DATA",data)
    state.agencyData = data.data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}